import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { useCurrentAccountId } from '../useCurrentAccountId';
import { invoices as InvoicesQueryData } from '@zapier/payment/src/types';

export const invoicesQuery = gql`
  query invoices($accountId: Int!) {
    account(id: $accountId) {
      id
      invoices {
        id
        createdAt
        hasPendingPayment
      }
    }
  }
`;

const usePendingPayment = () => {
  const { accountId } = useCurrentAccountId();
  const { data, loading } = useQuery<InvoicesQueryData>(invoicesQuery, {
    skip: !accountId,
    variables: { accountId },
  });

  const pendingInvoice = data?.account?.invoices?.find(
    invoice => invoice.hasPendingPayment
  );

  return {
    pendingInvoice,
    isLoading: loading,
  };
};

export default usePendingPayment;
